import { AsideSlice } from '../../prismicio-types'
import { asHTML } from '@prismicio/client'
import linkResolver from '../linkResolver'
import styles from './Aside.module.css'

export class Aside {
	static render(props: AsideSlice) {
		const { primary: { text } = {} } = props

		return /* HTML */ ` <div class="${styles.Main}">${asHTML(text, { linkResolver })}</div> `
	}
}
